<template>
  <main class="relative mx-auto w-full max-w-[10rem] min-h-screen min-h-[100svh] overflow-hidden bg-[#191e21] font-['PingFang_SC','Helvetica_Neue',Arial,sans-serif] text-white">
    <div
      class="absolute inset-0 bg-cover bg-top bg-no-repeat"
      :style="{ backgroundImage: `url(${assets.BG})` }"
      aria-hidden="true"
    ></div>

    <div class="relative z-[1] flex min-h-[100svh] flex-col px-[20px] pb-[18px]">
      <div class="pointer-events-none flex justify-center" aria-hidden="true">
        <img :src="assets.TITLE" alt="" class="mt-[100px] h-[39px] w-[226px] object-fill" />
      </div>

      <section class="mt-[195px] flex flex-col items-center">
        <h1 class="m-0 text-center text-[20px] font-medium leading-[1.5] tracking-[0.12em] font-santi">
          欢迎使用三体 THREE-BODY<br />官方防伪验证系统
        </h1>

        <div class="mt-[18px] w-full">
          <label
            class="relative mx-auto flex aspect-[104/15] w-[312px] items-center rounded-[12px] bg-[rgba(254,233,191,0.25)] p-[12px_45px_13px_12px] transition-colors focus-within:bg-[rgba(254,233,191,0.32)]"
            :class="{ '!bg-[rgba(255,110,90,0.2)]': errorMsg }"
          >
            <input
              v-model.trim="value"
              type="text"
              maxlength="40"
              autocomplete="off"
              placeholder="请输入防伪码"
              aria-label="请输入防伪码"
              class="min-w-0 w-full border-0 bg-transparent text-[15px] tracking-[0.06em] text-white outline-none placeholder:text-white/40"
              @keyup.enter="submit"
            />
            <button
              v-if="value"
              type="button"
              aria-label="清空防伪码"
              class="absolute right-[12px] top-1/2 flex h-[26px] w-[26px] -translate-y-1/2 cursor-pointer items-center justify-center overflow-hidden rounded-full border-0 bg-[rgba(255,255,255,0.18)]"
              @click="cleanValue"
            >
              <img :src="assets.CLEAR" alt="" class="h-full w-full object-contain" />
            </button>
          </label>
          <p
            class="mt-[7px] min-h-[20px] text-center text-[13px] tracking-[0.08em] text-[#ECEDF0]"
            :class="{ 'text-[#ff9a82]': errorMsg }"
          >
            {{ errorMsg || "输入防伪码验证真伪" }}
          </p>
        </div>

        <button
          type="button"
          class="relative mt-[138px] h-[41px] w-full max-w-[276px] cursor-pointer border-0 bg-transparent p-0 transition hover:brightness-[1.08] active:scale-[0.98]"
          @click="value ? submit() : goSao()"
        >
          <img :src="value ? assets.SUBMIT : assets.BUTTON" :alt="value ? '点击查询' : '扫码查询'" class="block h-auto w-full" />
        </button>
        <p class="mt-[17px] text-[16px] tracking-[0.1em] font-santi">输入防伪码验证</p>
      </section>

      <footer class="mt-[25px] flex justify-center">
        <img :src="assets.BOTTOM" alt="三体宇宙" class="block h-[26px] w-[147px] object-contain" />
      </footer>
    </div>

    <div class="absolute right-[21px] bottom-[18px] z-[1]">
      <img :src="assets.RIGHT_LOGO" alt="三体宇宙" class="block h-[9px] w-[43px] object-contain" />
    </div>
  </main>
</template>

<script>
import axios from "axios";

const BG = "https://wxamp-test-1308345661.cos.ap-shanghai.myqcloud.com/static/frontEnd/fenshe/badge_v2/authorization/bg.png";
const TITLE = "https://wxamp-test-1308345661.cos.ap-shanghai.myqcloud.com/static/frontEnd/fenshe/badge_v2/authorization/title_icon.png";
const BUTTON = "https://wxamp-test-1308345661.cos.ap-shanghai.myqcloud.com/static/frontEnd/fenshe/badge_v2/authorization/btn.png";
const BOTTOM = "https://wxamp-test-1308345661.cos.ap-shanghai.myqcloud.com/static/frontEnd/fenshe/badge_v2/authorization/bottom_icon.png";
const RIGHT_LOGO = "https://wxamp-test-1308345661.cos.ap-shanghai.myqcloud.com/static/frontEnd/fenshe/badge_v2/authorization/right_logo.png";
const CLEAR = "https://wxamp-test-1308345661.cos.ap-shanghai.myqcloud.com/static/frontEnd/fenshe/badge_v2/authorization/clear.png";
const SUBMIT = "https://wxamp-test-1308345661.cos.ap-shanghai.myqcloud.com/static/frontEnd/fenshe/badge_v2/authorization/submit.png";

export default {
  data() {
    return {
      assets: { BG, TITLE, BUTTON, BOTTOM, CLEAR, SUBMIT, RIGHT_LOGO },
      value: "",
      errorMsg: "",
      product_info: ""
    };
  },
  created() {
    this.initWechatSDK();
    const params = this.$route.fullPath.split("?")[1];
    if (params) {
      this.value = params;
    }
  },
  methods: {
    cleanValue() {
      this.value = "";
    },
    async submit() {
      if (!this.value) {
        this.showError("请输入防伪码");
        return;
      }
      const isValid = await this.getProductInfo();
      if (isValid) {
        this.$router.push({ path: "/productInfo", query: { value: this.product_info } });
      }
    },
    goSao() {
      this.$router.push("/saoyisao");
    },
    initWechatSDK() {},
    async getProductInfo() {
      try {
        const response = await axios.post("https://info-api.threebody.com/anti/router", { code: this.value });
        if (response.status === 200 && response.data.IsSuccess) {
          this.product_info = response.data.ResponseData;
          return true;
        }
        this.showError(response.data.message || "验证失败，请重试");
      } catch (error) {
        this.showError("网络异常，请稍后重试");
      }
      return false;
    },
    showError(msg) {
      this.errorMsg = msg;
      setTimeout(() => {
        this.errorMsg = "";
      }, 3000);
    }
  }
};
</script>

<style>
@media (min-width: 751px) {
  body {
    background: #0d1012;
  }
}
</style>
